<app-common-modal
  #modal
  [modalClass]="'modal-upload'"
  [config]="{size: 'sm'}"
  [commonModalConfig]="{ header: true, body: true, footer: true }"
  >
  <ng-container ModalHeader>
    <div class="warning im2-title">
      {{ "COMMON.UPLOAD_" + ( isVideo()? 'VIDEO' : 'IMAGE')  | translate }}
    </div>
    <!--begin::Close-->
    <app-icon-button
      title="close"
      [iconOnly]="true"
      iconType="fa-solid"
      iconClass="fa-xmark text-primary"
      (click)="cancel()"
    ></app-icon-button>
    <!--end::Close-->
  </ng-container>
  <ng-container ModalBody>
    <form [formGroup]="form" *ngIf="media">
      <div class="row">
        <div class="col">
          <app-field-label
            [isMandatory]="true"
            inputId=""
            labelKey="COMMON.TITLE"
          ></app-field-label>
          <div class="mb-6">
            <input
              [readOnly]="isTitleFixed()"
              [ngClass]="{ 'is-invalid': invalidField(form.controls['title']) }"
              class="form-control {{ isTitleFixed()? 'is-forbidden' : ''}}"
              [placeholder]="'COMMON.TITLE' | translate"
              formControlName="title"
            />
            <div class="text-danger" *ngIf="invalidField(form.controls['title'])">
              {{ getError(form.controls.title) | translate: { fieldName: 'COMMON.TITLE' | translate} }}
            </div>
          </div>

          <app-field-label
            inputId=""
            [labelKey]="
              isVideo()
                ? 'COMMON.UPLOAD_VIDEO'
                : 'COMMON.UPLOAD_IMAGE'
            "
            [isMandatory]="true"
          ></app-field-label>
          <app-upload-image-box
            #uploadBox
            [media]="media"
            [error]="mediaEmptyError"
            [isVideo]="isVideo()"
            (previewHandler)="previewClicked()"
            (deleteHandler)="uploadBox.deleteFile()"
            [promptText]="getPromptTextForUploadBox()"
          ></app-upload-image-box>
        </div>

        <div class="col d-none">
          <div
            class="ticketBox"
            [ngClass]="{
            ticketBoxActive: form.controls.ticket.value,
            }"
          >
            <input
              type="checkbox"
              formControlName="ticket"
              class="form-check-input"
              (change)="updateFormValidators()"
            />
            <label class="form-check-label mx-3">{{
              (isVideo()
                ? "INSPECTION.CREATE_TICKET_VIDEO"
                : "INSPECTION.CREATE_TICKET_IMAGE"
              ) | translate
            }}</label>
          </div>
          <div
            class="ticketBoxContent"
            *ngIf="form.controls.ticket.value"
          >
            <app-field-label
              inputId=""
              [isMandatory]="true"
              labelKey="INSPECTION.TICKET_CATEGORY"
            ></app-field-label>
            <div class="table-responsive mt-2">
              <table
                class="table table-bordered"
                [ngClass]="{ 'border-danger': invalidField(form.controls['category']) }"
                [attr.aria-describedby]="
                  'INSPECTION.TICKET_CATEGORY' | translate
                "
              >
                <tr
                  *ngFor="let type of typeSelection"
                  [ngClass]="{
                    selected: radioCategory.checked
                  }"
                >
                  <th>
                    <div class="d-flex align-items-center">
                      <input
                        #radioCategory
                        type="radio"
                        class="form-check-input"
                        formControlName="category"
                        [value]="type"
                      />
                      <label class="form-check-label mx-3">{{
                        'COMMON.' + type | translate
                      }}</label>
                    </div>
                  </th>
                </tr>
              </table>
              <div class="text-danger" *ngIf="invalidField(form.controls['category'])">
                {{ getError(form.controls.category) | translate: { fieldName: 'INSPECTION.TICKET_CATEGORY' | translate} }}
              </div>
            </div>

            <div class="form-group">
              <app-field-label
                inputId="comment"
                [isMandatory]="true"
                labelKey="COMMON.COMMENT"
              ></app-field-label>
              <textarea
                class="form-control"
                [ngClass]="{ 'is-invalid': invalidField(form.controls['comment']) }"
                [placeholder]="'COMMON.COMMENT' | translate"
                rows="6"
                cols="1"
                formControlName="comment"
              ></textarea>
              <div class="invalid-feedback" *ngIf="invalidField(form.controls['comment'])">
                {{ getError(form.controls.comment) | translate: { fieldName: 'COMMON.COMMENT' | translate} }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container ModalFooter>
    <app-icon-button
      (click)="onSave()"
      extraClasses="btn-primary"
      [outlined]="true"
      [label]="'COMMON.SAVE'">
    </app-icon-button>
  </ng-container>
</app-common-modal>
